module.exports = __webpack_public_path__ + "static/media/Wonder women 1.cd9ba85a.jpg";